<header class="header">
  <div class="header__left">
    <ng-content select="[left]"></ng-content>
  </div>
  <div class="header__center">
    <ng-content select="[center]"></ng-content>
  </div>
  <div class="header__right">
    <ng-content select="[right]"></ng-content>
  </div>
</header>
